<template>
  <ResumeSection v-if="$get(userStories, 'length')"
                 :toggle="!isToggleHidden"
                 :isOpen="isOpenOnMobile"
                 :title="$tResumePage('User actions')"
                 class="resume-page__section  _grow" style="flex-grow: unset;">
    <template v-slot:icon>
      <BaseSvg name="ico-see" width="3rem" height="2rem"/>
    </template>
    <template v-slot:default>
      <div class="resume-user-actions">
        <div class="resume-user-actions__content  custom-scrollbar">
          <div v-for="(story, index) in userStories"
               :key="story.datetime + index"
               class="resume-user-actions__item">
            <time class="resume-user-actions__item-time">
              {{ story.datetime }}
            </time>
            <div v-html="story.action"
                 class="resume-user-actions__item-action"></div>
          </div>
        </div>
      </div>
    </template>
  </ResumeSection>
</template>

<script>
  import formatDate from '@/helpers/formatDate';
  import ResumeSection from './ResumeSection';

  export default {
    name: 'ResumeActionsSection',
    components: {
      ResumeSection
    },
    props: {
      userStories: Array,
      isOpenOnMobile: Boolean,
      isToggleHidden: Boolean,
    },
    data() {
      return {}
    },
    methods: {
      formatDate
    }
  }
</script>

<style lang="less">

</style>
